import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import selectStyle from "../../../design/selectStyle";
import currencies from "../../../services/currencies.json"
import Select from "react-select"

const PaymentOrderInfo = ({ invoice,handleChange }) => {
    const { t } = useTranslation("translations");
    
    return (
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 d-flex">
                  <div className=" w-100 mb-4">
                    <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="recordDate">
                            {t("table.recordDate")}
                          </label>
                          <input
                            type="text"
                            name="recordDate"
                            id="recordDate"
                            className="form-control"
                            value={moment(invoice?.recordDate).format("DD/MM/YYYY")  ?? ""}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="docNumber">
                          Account Reference Type
                          </label>
                          <input
                            type="text"
                            name="creditorAccountReferenceType"
                            id="creditorAccountReferenceType"
                            className="form-control"
                            value={invoice?.creditorAccountReferenceType ?? ""}
                            disabled
                          />
                        </div>
                      </div> 
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="endToEndId">{t("home.status")}</label>
                          <input
                            type="text"
                            name="status.name"
                            className="form-control"
                            value={invoice?.status?.name ?? ""}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="endToEndId">Identifier</label>
                          <input
                            type="text"
                            name="endToEndId"
                            id="endToEndId"
                            className="form-control"
                            value={invoice?.endToEndId ?? ""}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="ammount">{t("home.amount")}</label>
                          <input
                            type="number"
                            name="amount"
                            id="amount"
                            className="form-control"
                            onChange={handleChange}
                            value={invoice?.amount ?? ""}
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="currency">{t("invoice.currency")}</label>
                          <Select
                            styles={selectStyle}
                            options={currencies}
                            isSearchable={true}
                            onChange={(currency) => handleChange(null,"currency",currency.value)}
                            getOptionValue={(opt)=>opt.value}
                            getOptionLabel={(opt)=>opt.value}
                            value={ currencies.find(currency=>currency.value===invoice?.currency) }
                            menuPlacement="auto"
                            isDisabled={true}
                            />
                        </div>
                      </div> */}

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="curency">{t("invoice.currency")}</label>
                    <input
                      type="text"
                      name="currency"
                      id="currency"
                      className="form-control"
                      onChange={handleChange}
                      value={invoice?.purchaseInvoice.purchaseInvoiceExtracted.currency ?? ""}
                      disabled
                    />
                  </div>
                </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="creditorAccountReference">Creditor Account Reference </label>
                          <input
                            type="text"
                            name="creditorAccountReference"
                            className="form-control"
                            value={invoice?.creditorAccountReference ?? ""}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    );
};

export default PaymentOrderInfo;
